// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overlay-view {
  border: 0 solid transparent;
  background: var(--background-base-alpha-01, rgba(0, 30, 34, 0.6));
  position: fixed;
  width: 100%;
  height: 100vh;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  z-index: 5;
}
.overlay-view.-visible {
  visibility: visible;
}
.overlay-view.-hidden {
  visibility: hidden;
}
.overlay-view .loader {
  border: 0 solid transparent;
  background-color: transparent;
  width: 96px;
  height: 96px;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  max-width: 100%;
  max-height: 100%;
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./projects/dashboard-new/src/app/loader/loader.component.scss"],"names":[],"mappings":"AAAA;EACE,2BAAA;EACA,iEAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;AACF;AACE;EACE,mBAAA;AACJ;AAEE;EACE,kBAAA;AAAJ;AAGE;EACE,2BAAA;EACA,6BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AADJ","sourcesContent":[".overlay-view {\r\n  border: 0 solid transparent;\r\n  background: var(--background-base-alpha-01, rgba(0, 30, 34, 0.60));\r\n  position: fixed;\r\n  width: 100%;\r\n  height: 100vh;\r\n  justify-content: center;\r\n  align-items: center;\r\n  top: 0;\r\n  left: 0;\r\n  z-index: 5;\r\n\r\n  &.-visible {\r\n    visibility: visible;\r\n  }\r\n\r\n  &.-hidden {\r\n    visibility: hidden;\r\n  }\r\n\r\n  .loader {\r\n    border: 0 solid transparent;\r\n    background-color: transparent;\r\n    width: 96px;\r\n    height: 96px;\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    top: 0;\r\n    bottom: 0;\r\n    margin: auto;\r\n    max-width: 100%;\r\n    max-height: 100%;\r\n    overflow: hidden;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
